import React, { Dispatch, SetStateAction } from "react";
import { useState } from "react";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { handleExport } from "../../utils/exportCsvFunction";
import { useLazyExportUsersQuery } from "../../service/users";
import { showToast } from "../../constants/toasts";
import usePermission from "../../hooks/usePermission";

const UserTopbar = ({
  setDebouceSearchTerm,
  debouceSearchTerm,
  page,
}: {
  setDebouceSearchTerm: Dispatch<SetStateAction<string>>;
  debouceSearchTerm: string;
  page: number;
}) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { isAdd } = usePermission({
    label: "Manage Users",
    page_permission: "isView",
  });
  const [Status, setStatus] = React.useState("default");
  const [exportUser] = useLazyExportUsersQuery();
  const navigate = useNavigate();
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const handleCsv = () => {
    handleExport(
      exportUser({
        page,
        limit: 10,
        ...(debouceSearchTerm && { search: debouceSearchTerm }),
      }),
      "user"
    );
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            setDebouncedSearchTerm={setDebouceSearchTerm}
            placeholder="Search..."
          />
        </div>
        <div className="right_s">
          {isAdd && (
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-users/add")}
            >
              <AddIcon /> Add User
            </Button>
          )}
          <Button onClick={handleCsv} className="btn btn_black">
            <FileDownloadIcon /> Export CSV
          </Button>
        </div>
      </div>
    </>
  );
};

export default UserTopbar;
